import { ChangeEventHandler,useEffect, useState } from 'react';

import {
    Dialog,
    DialogTitle,
} from '@mui/material';

import { TextAreaPopoutCloseIcon } from './TextAreaPopoutCloseIcon';
import { TextAreaPopoutInputBase, TextAreaPopoutInputBaseProps } from './TextAreaPopoutInputBase';
import { TextAreaPopoutInputLabel } from './TextAreaPopoutInputLabel';

export type TextAreaPopoutCommonProps = {
    open: boolean;
    value: string;
    onClose: (value: string) => void;
};

export type TextAreaPopoutProps = {
    commonPopoutProps: TextAreaPopoutCommonProps,
    popoutInputLabel: string,
    popoutInputBaseProps: Pick<TextAreaPopoutInputBaseProps, 'inputBasePlaceholder'>,
}

export function TextAreaPopout({
    commonPopoutProps,
    popoutInputLabel,
    popoutInputBaseProps,
}: Readonly<TextAreaPopoutProps>) {
    const { onClose, value, open } = commonPopoutProps;
    const { inputBasePlaceholder } = popoutInputBaseProps;
    const [popoutValue, setPopoutValue] = useState(value);

    useEffect(() => {
        setPopoutValue(value);
    }, [value]);

    const handleClose = () => {
        onClose(popoutValue);
    };

    const handleNotesFieldChange: ChangeEventHandler<HTMLInputElement> = event => {
        setPopoutValue(event.target.value);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='sm'
            PaperProps={{
                sx: {
                    maxHeight: '60vh',
                    minHeight: '50vh'
                }
            }}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                <TextAreaPopoutInputLabel label={popoutInputLabel}/>
                <TextAreaPopoutCloseIcon onClickHandler={handleClose}/>
            </DialogTitle>
            <TextAreaPopoutInputBase
                inputBaseChangeHandler={handleNotesFieldChange}
                inputBasePlaceholder={inputBasePlaceholder}
                value={popoutValue}
            />
        </Dialog>
    );
}
